module.exports = __webpack_public_path__ + "assets/img/btn-view-d0da30b6.png";